import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ResponseCodeEnum } from '../Entity/response.enum';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private messageService: MessageService) {}

  showCommonAlertMessage(responseMessage: string, responseCode?: string) {
    if (responseCode === ResponseCodeEnum.OPERATION_SUCCESSFUL) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: responseMessage });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: responseMessage });
    }
  }
}
